import { RequestCustomerStatus, getContractEndOptionStatusEndpoint } from 'cpfr-common';
import { DefaultBusinessMarketApiErrorCode } from '@cp-shared-19/common-utilities';
import { getSimpleDataFetchSlice } from '@cp-shared-19/frontend-integration';
import { CpDataApi } from 'cp-xhr';

const { reducer, fetchData, updateData } = getSimpleDataFetchSlice<
    RequestCustomerStatus,
    DefaultBusinessMarketApiErrorCode
>({
    dataName: 'ContractEndOptionChangeStatus',
    fetchCallback() {
        return CpDataApi.get<RequestCustomerStatus>(getContractEndOptionStatusEndpoint()).then(
            (response) => response.data,
        );
    },
});

export default reducer;
export const fetchContractEndOptionChangeStatus = fetchData;
export const updateContractEndOptionChangeStatus = updateData;
